import http from "./base";

class PerformerService{
    constructor(){}

    async saveNewPerformer(performerItem) {
        const url = `performers`;
        var response = "";
        await http
            .post(url, performerItem,{
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async updatePerformerByID(id,body) {
        const url = `performers/`+id;
        var response = "";
        await http
            .patch(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async deletePerformerID(id) {
        const url = `performers/`+id;
        var response = "";
        await http
            .delete(url,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async getAllPerformers(stage_ID)  {
        const url = `performers/getAll/`+stage_ID;

        var response = "";
        await http
            .get(url, {
                cache: false
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async getSignPerformerS3URL(picture) {
            const url = `performers/`;
            var response = "";
            await http
                .get(url, {
                    params:{
                        type:picture
                    },
                    cache: false
                },)
                .then(responseData => {
                    response = responseData.data.data;
                })
                .catch(error => {
                    response = error.response;
                    throw new Error(`HTTP error! status: ${response.status}`);
                });
    
            return response;
        }



}

let service = new PerformerService();
export default service;



